const TOTAL = 100;

export const parsePercent = (percent: number) => {
  if (percent >= TOTAL) {
    return 99;
  } else if (percent <= 0) {
    return 0;
  } else return percent.toFixed(0);
};
